import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { SohoDataGridComponent } from "ids-enterprise-ng";
import { CapacityModelService } from "../services/CapacityModel-Service";
import { Router, NavigationExtras } from "@angular/router";
import { SohoModalDialogService, SohoBusyIndicatorDirective } from 'ids-enterprise-ng';
import { UserData } from '../shared/models/user.model';
import { AuthHelper } from './../services/authHelper';
import { filterPayCurveColumns } from '../services/fiscal-year.helper';

@Component({
  selector: 'app-detailed-upload',
  templateUrl: './detailed-upload.component.html',
  styleUrls: ['./detailed-upload.component.css']
})
export class DetailedUploadComponent implements OnInit {
  @ViewChild(SohoDataGridComponent) datagrid!: SohoDataGridComponent;
  @ViewChild(SohoBusyIndicatorDirective, { static: true }) busyIndicator?: SohoBusyIndicatorDirective;
  showBusy = true;
  Message = "Loading...";
  isvalid!: boolean;
  public data!: any[];
  public grid_Columns!: SohoDataGridColumn[];
  public GrdRequests: any;
  public filteredRequests: any;
  public filteredArray: any[] = [];
  public filteredIds: any[] = [];
  constructor(private capacityModelService: CapacityModelService,
    private router: Router,
    private modalService: SohoModalDialogService,
    private authhelper: AuthHelper,
    private ngZone: NgZone) { }
  emailAddress!: string;
  userData = new UserData();
  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem("userprofile")!);
    if (this.userData == null || this.userData == undefined || this.userData.SecurityroleDescription == "") {
      this.authhelper.setUserRoleAndLoginDetails();
    }
    this.emailAddress = this.userData.Email;
    this.GetDetailedQuotas(); 
  }

  GetDetailedQuotas() {
    this.data = [];
    this.grid_Columns = [];
    this.start();
    this.capacityModelService.GetDetailedQuotasData(this.userData.Email).subscribe(
      detailedquotas => {
        this.data = detailedquotas;
        this.grid_Columns = filterPayCurveColumns(this.gridColumns);
        if (this.data != null) {
          this.GrdRequests = $("#Requestdatagrid").datagrid().data();
          this.GrdRequests.datagrid.renderRows();
          this.stop();
        }
      },
      (error: Response) => {
        this.stop();
        console.log(error);
      }
    );

  }
  onClick(args: any) {
    console.log(args);
    localStorage.setItem("uniqueid", args["0"].item.uniqueid);
    let navigationExtras: NavigationExtras = {
      queryParams: {
        uniqueid: args["0"].item.uniqueid
      }
    };
    //$("#divTerritoryBudgets").removeClass("is-selected");
    //$("#divTerritoryBudgets").addClass("is-selected");
    this.ngZone.run(() => this.router.navigate(["EditDetailedUpload"], navigationExtras)).then();
    //this.router.navigate(["EditProject"], navigationExtras);
  }
  onselectionChanged(args: any) {
    console.log(args);
  }
  DeleteQuotas() {
    this.InitiateDeletion();
  }
  SubmitQuotas() {
    this.InitiateApproval();
  }

  InitiateDeletion() {
    let selectedid: any[] = [];
    let filterid!: any;
    this.filteredArray = [];
    var selectedRowsCount = this.GrdRequests.datagrid.selectedRows().length;
    //console.log(selectedRowsCount);
    if (selectedRowsCount <= 0) {
      this.filteredArray = [];
    }
    else {

      for (var i = 0; i < selectedRowsCount; i++) {
        this.filteredRequests = false;
        if (this.GrdRequests.datagrid.selectedRows()[i].data.isFiltered == undefined) {
          this.filteredRequests = true
        }
        else if (!this.GrdRequests.datagrid.selectedRows()[i].data.isFiltered) {
          this.filteredRequests = true
        }
        if (this.filteredRequests) {
          this.filteredIds = this.GrdRequests.datagrid.selectedRows()[i].data.uniqueid;
          this.filteredArray.push(this.filteredIds);
        }

      }
    }
    if (this.filteredArray.length > 0) {
      this.start();
      for (var i = 0; i < this.filteredArray.length; i++) {
        filterid = <JSON><unknown>{ "uniqueid": this.filteredArray[i], "userlogin": this.emailAddress == null ? "rameshbabu.kollu@infor.com" : this.emailAddress };
        selectedid.push(filterid);
      }
      this.capacityModelService.DeleteDetailedQuotas(selectedid).subscribe(
        response => {
          this.ShowAlert("Confirmation", "Quotas deleted successfully.");
          this.stop();
          this.GetDetailedQuotas();

        },
        (error: Response) => {
          console.log(error);
          this.stop();
          this.ShowAlert("Alert", "Error while deleting the Quota/s.");

        }
      );
    }
    else {
      this.ShowAlert("Information", "Please select atleast one Quota to delete.");
    }
  }
  InitiateApproval() {
    let selectedid: any[] = [];
    let filterid!: any;
    this.filteredArray = [];
    var selectedRowsCount = this.GrdRequests.datagrid.selectedRows().length;
    this.isvalid = true;
    // console.log(selectedRowsCount);
    if (selectedRowsCount <= 0) {
      this.filteredArray = [];
    }
    else {

      for (var i = 0; i < selectedRowsCount; i++) {
        this.filteredRequests = false;
        if (this.GrdRequests.datagrid.selectedRows()[i].data.isFiltered == undefined) {
          this.filteredRequests = true
        }
        else if (!this.GrdRequests.datagrid.selectedRows()[i].data.isFiltered) {
          this.filteredRequests = true
        }
        if (this.filteredRequests) {
          this.filteredIds = this.GrdRequests.datagrid.selectedRows()[i].data.uniqueid;
          this.filteredArray.push(this.filteredIds);
          if (this.GrdRequests.datagrid.selectedRows()[i].data.holdrecord == true) { this.isvalid = false };
        }

      }
    }
    if (this.isvalid) {
      if (this.filteredArray.length > 0) {
        this.start();
        for (var i = 0; i < this.filteredArray.length; i++) {
          filterid = <JSON><unknown>{ "uniqueid": this.filteredArray[i], "userlogin": this.emailAddress == null ? "rameshbabu.kollu@infor.com" : this.emailAddress };
          selectedid.push(filterid);
        }
        this.capacityModelService.CreateFinalQuotaList(selectedid).subscribe(
          response => {
            this.ShowAlert("Confirmation", "Quotas submitted successfully.");
            this.stop();
            this.GetDetailedQuotas();

          },
          (error: Response) => {
            console.log(error);
            this.stop();
            this.ShowAlert("Alert", "Error while submitting the Quotas.");
          }
        );
      }
      else {
        this.ShowAlert("Information", "Please select atleast one Quota to submit.");
      }
    }
    else {
      this.ShowAlert("Information", "There are records with Hold status flag ON, please de-select them and try again.");
    }
  }
  ShowAlert(Title: any, Message: any) {
    const dialogRef1 = this.modalService
      .message("<h2>" + Message + "</h2>")
      .buttons([
        {
          text: "Ok",
          click: () => {
            dialogRef1.close("Ok");

          },
          isDefault: true
        }
      ])
      .title(Title)
      .open()
      .frameHeight(1000);
  }
  start() {
    (this.busyIndicator as any).activated = true;
  }

  stop() {
    (this.busyIndicator as any).activated = false;
  }
  gridColumns = [
    {
      id: 'selectionCheckbox',
      sortable: false,
      resizable: false,
      formatter: Soho.Formatters.SelectionCheckbox,
      align: 'center'
    },
    {
      id: "button-formatter",
      name: "Edit",
      text: "Edit Row",
      icon: "edit",
      align: "center",
      sortable: false,
      formatter: Soho.Formatters.Button,
      click: (e: any, args: any) => this.onClick(args)
    },
    {
      id: "uniqueid",
      name: "Unique ID",
      field: "uniqueid",
      hidden: true,
      formatter: Soho.Formatters.Text
    },
    {
      id: "managername",
      name: "Manager Name",
      sortable: true,
      field: "managername",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "managerid",
      name: "Manager HCM",
      field: "managerid",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "employeeid",
      name: "Employee ID",
      sortable: true,
      field: "employeeid",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "employeefirstname",
      name: "Employee First Name",
      field: "employeefirstname",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "employeelastname",
      name: "Employee Last Name",
      field: "employeelastname",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "salesunit",
      name: "Sales Unit",
      field: "salesunit",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "lob",
      name: "LOB",
      field: "lob",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "perpetualmultiplier",
      name: "Perpetual Multiplier",
      field: "perpetualmultiplier",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "saasmultiplierlt3years",
      name: "SaaS Multiplier < 1 Year",
      field: "saasmultipliergt2lt3years",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "saasmultipliergt1lt2years",
      name: "SaaS Multiplier > 1 and < 2 Years",
      field: "saasmultipliergt1lt2years",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "saasmultipliergt3years",
      name: "SaaS Multiplier > 2 Years",
      field: "saasmultipliergt3years",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    // {
    //   id: "perpetuallogomultiplier",
    //   name: "MES Multiplier",
    //   field: "perpetuallogomultiplier",
    //   filterType: 'decimal',
    //   formatter: Soho.Formatters.Decimal,
    //   numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    // },
    {
      id: "reprole",
      name: "Rep Role",
      field: "reprole",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "variabletype",
      name: "Variable Type",
      field: "variabletype",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "holdrecord",
      name: "Hold Record",
      field: "holdrecord",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "plantype",
      name: "Plan Type",
      field: "plantype",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "planstartdate",
      name: "Plan Startdate",
      field: "planstartdate",
      filterType: 'date',
      formatter: Soho.Formatters.Date,
      dateFormat: 'M/d/yyyy'
    },
    {
      id: "variablepay",
      name: "Variable Pay",
      field: "variablepay",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "variablepaycurrency",
      name: "Variable Pay Currency",
      field: "variablepaycurrency",

      formatter: Soho.Formatters.Text
    },
    {
      id: "perpetualquota",
      name: "Perpetual Quota",
      field: "perpetualquota",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "saaslt3yearquota",
      name: "SaaS < 3 Year Quota",
      field: "saaslt3yearquota",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "saasgt3yearquota",
      name: "SaaS > 3 Year Quota",
      field: "saasgt3yearquota",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "element1",
      name: "Element 1",
      field: "element1",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
    },
    {
      id: "paycurve1",
      name: "Pay Curve 1",
      field: "paycurve1",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
    },
    {
      id: "territorygroup",
      name: "Territory Group1",
      field: "territorygroup",
      filterType: 'text',

      formatter: Soho.Formatters.Text
    },
    {
      id: "totalquota",
      name: "Total Quota1",
      field: "totalquota",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: false }
    },
    {
      id: "proratedtotalquota1",
      name: "Prorated Total Quota 1",
      field: "proratedtotalquota1",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2  }
    },
    {
      id: "element2",
      name: "Element 2",
      field: "element2",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
    },
    {
      id: "paycurve2",
      name: "Pay Curve 2",
      field: "paycurve2",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
    },
    {
      id: "territorygroup2",
      name: "Territory Group2",
      field: "territorygroup2",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    
    {
      id: "totalquota2",
      name: "Total Quota 2",
      field: "totalquota2",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    },
    {
      id: "proratedtotalquota2",
      name: "Prorated Total Quota 2",
      field: "proratedtotalquota2",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2}
    },
    {
      id: "element3",
      name: "Element 3",
      field: "element3",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
    },
    {
      id: "paycurve3",
      name: "Pay Curve 3",
      field: "paycurve3",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
    },
    {
      id: "territorygroup3",
      name: "Territory Group3",
      field: "territorygroup3",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "totalquota3",
      name: "Total Quota 3",
      field: "totalquota3",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    },
    {
      id: "proratedtotalquota3",
      name: "Prorated Total Quota 3",
      field: "proratedtotalquota3",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    },
    {
      id: "element4",
      name: "Element 4",
      field: "element4",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
    },
    {
      id: "paycurve4",
      name: "Pay Curve 4",
      field: "paycurve4",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
    },
    {
      id: "territorygroup4",
      name: "Territory Group4",
      field: "territorygroup4",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "totalquota4",
      name: "Total Quota 4",
      field: "totalquota4",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2}
    },
    {
      id: "proratedtotalquota4",
      name: "Prorated Total Quota 4",
      field: "proratedtotalquota4",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    },
    {
      id: "element5",
      name: "Element 5",
      field: "element5",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
    },
    {
      id: "paycurve5",
      name: "Pay Curve 5",
      field: "paycurve5",
      filterType: 'text',
      formatter: Soho.Formatters.Text,
    },
    {
      id: "territorygroup5",
      name: "Territory Group5",
      field: "territorygroup5",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "totalquota5",
      name: "Total Quota 5",
      field: "totalquota5",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    },
    {
      id: "q1_1",
      name: "Element 1 Q1",
      field: "q1_1",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q2_1",
      name: "Element 1 Q2",
      field: "q2_1",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q3_1",
      name: "Element 1 Q3",
      field: "q3_1",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q4_1",
      name: "Element 1 Q4",
      field: "q4_1",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q1_2",
      name: "Element 2 Q1",
      field: "q1_2",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q2_2",
      name: "Element 2 Q2",
      field: "q2_2",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q3_2",
      name: "Element 2 Q3",
      field: "q3_2",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q4_2",
      name: "Element 2 Q4",
      field: "q4_2",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q1_3",
      name: "Element 3 Q1",
      field: "q1_3",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q2_3",
      name: "Element 3 Q2",
      field: "q2_3",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q3_3",
      name: "Element 3 Q3",
      field: "q3_3",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q4_3",
      name: "Element 3 Q4",
      field: "q4_3",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q1_4",
      name: "Element 4 Q1",
      field: "q1_4",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q2_4",
      name: "Element 4 Q2",
      field: "q2_4",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q3_4",
      name: "Element 4 Q3",
      field: "q3_4",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q4_4",
      name: "Element 4 Q4",
      field: "q4_4",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q1_5",
      name: "Element 5 Q1",
      field: "q1_5",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q2_5",
      name: "Element 5 Q2",
      field: "q2_5",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q3_5",
      name: "Element 5 Q3",
      field: "q3_5",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "q4_5",
      name: "Element 5 Q4",
      field: "q4_5",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "fiscalyear",
      name: "FiscalYear",
      field: "fiscalyear",
      filterType: 'text',

      formatter: Soho.Formatters.Text
    },
    
    {
      id: "quotacurrency",
      name: "Quota Currency",
      field: "quotacurrency",
      filterType: 'text',

      formatter: Soho.Formatters.Text
    },
    {
      id: "countryname",
      name: "Country Name",
      field: "countryname",
      filterType: 'text',

      formatter: Soho.Formatters.Text
    },
    {
      id: "functionalarea",
      name: "Function",
      field: "functionalarea",
      filterType: 'text',

      formatter: Soho.Formatters.Text
    },
    {
      id: "department",
      name: "Department",
      field: "department",
      filterType: 'text',

      formatter: Soho.Formatters.Text
    },
    {
      id: "departmentpercrm",
      name: "Department Per CRM",
      field: "departmentpercrm",
      filterType: 'text',

      formatter: Soho.Formatters.Text
    },
    {
      id: "requestid",
      name: "Request ID",
      hidden: true,
      field: "requestid",

      formatter: Soho.Formatters.Text
    },
    {
      id: "employeestatus",
      name: "Employee Status",
      field: "employeestatus",
      filterType: 'text',
      sortable: false,
      formatter: Soho.Formatters.Text
    }, {
      id: "employeestartdate",
      name: "Employee Start Date",
      field: "employeestartdate",
      filterType: 'date',
      formatter: Soho.Formatters.Date,
      dateFormat: 'M/d/yyyy'
    }, {
      id: "prioryearplantype",
      name: "Prior Year Plan",
      field: "prioryearplantype",
      sortable: false,
      filterType: 'text',
      formatter: Soho.Formatters.Text
    }, {
      id: "prioryearquota",
      name: "Prior Year Quota",
      field: "prioryearquota",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    }, {
      id: "prioryearachievement",
      name: "Prior Year Achievement",
      field: "prioryearachievement",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    }, {
      id: "prioryearachievementpercent",
      name: "Prior Year Ach %",
      field: "prioryearachievementpercent",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    }, {
      id: "prioryearcurrency",
      name: "Prior Year Currency",
      field: "prioryearcurrency",
      filterType: 'text',

      formatter: Soho.Formatters.Text
    }, {
      id: "prioryearfxrate",
      name: "Prior Year FxRate",
      field: "prioryearfxrate",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 6, maximumFractionDigits: 6, round: true }
    }, {
      id: "currentyearfxrate",
      name: "Current Year FxRate",
      field: "currentyearfxrate",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 6, maximumFractionDigits: 6, round: true }
    }, {
      id: "region",
      name: "Region",
      field: "region",
      filterType: 'text',

      formatter: Soho.Formatters.Text
    }, {
      id: "variablepayusd",
      name: "Variable Pay USD",
      field: "variablepayusd",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true, style: 'currency' }
    }, {
      id: "prioryearquotausd",
      name: "Prior Year Quota USD",
      field: "prioryearquotausd",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true, style: 'currency' }
    }, {
      id: "prioryearachievementusd",
      name: "Prior Year Ach USD",
      field: "prioryearachievementusd",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true, style: 'currency' }
    }, {
      id: "currentyearquotausd",
      name: "Current Year Quota USD",
      field: "currentyearquotausd",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true, style: 'currency' }
    }, {
      id: "localquotayoy",
      name: "Local Quota YOY",
      field: "localquotayoy",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    }, {
      id: "baserate",
      name: "Base Rate",
      field: "baserate",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 6, maximumFractionDigits: 6, round: true }
    },
   
    {
      id: "createdby",
      name: "Created By",
      field: "createdby",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    },
    {
      id: "created",
      name: "Created On",
      field: "created",
      filterType: 'date',
      formatter: Soho.Formatters.Date,
      dateFormat: 'M/d/yyyy hh:mm:ss'
    },
    {
      id: "commentsadded",
      name: "Comments Added",
      field: "commentsadded",
      filterType: 'text',
      formatter: Soho.Formatters.Text
    }
  ];
}
